import { Flex, Logo } from "../atoms";
import { NavigationList } from "./navigation";
import { styled } from "utils";

const StyledFooter = styled(Flex, {
  marginTop: "$8",
  backgroundColor: "$lightgreen",
  paddingY: "$5",
  paddingX: "$7",
  fontSize: "$4",
  fontWeight: "$semibold",
  flexWrap: "wrap",
});

const Footer: React.FC = () => {
  return (
    <StyledFooter
      css={{
        alignItems: "start",
        flexDirection: "column",
        "@bp2": { alignItems: "center", flexDirection: "row" },
      }}
    >
      <Logo />
      <Flex
        css={{ marginTop: "$4", "@bp2": { marginTop: 0, marginLeft: "auto" } }}
      >
        <NavigationList
          css={{
            gap: "$4",
            flexDirection: "column",
            "@bp2": { gap: "$6", flexDirection: "row", alignItems: "center" },
          }}
        />
      </Flex>
    </StyledFooter>
  );
};

export { Footer };
